// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { activeStateTrue } from "@tps/App/Widgets/SearchEngineOptimization/ActiveState";
import { SeoAppProps, SeoHandlerProps } from "@tps/App/Widgets/SearchEngineOptimization/Type";
import { WebPage, WithContext } from "@tps/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaWebPage = ({ state, fields, url }: SeoAppProps): WithContext<WebPage> => {
    return {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: fields.organizationName || state.context.website.name,
        description: fields.description,
        url,
    };
};

export default {
    isActivate: activeStateTrue,
    buildSchema: loadSchemaWebPage,
} as SeoHandlerProps;
